import { render, staticRenderFns } from "./recommendList.vue?vue&type=template&id=008110fd&scoped=true"
import script from "./recommendList.vue?vue&type=script&lang=js"
export * from "./recommendList.vue?vue&type=script&lang=js"
import style0 from "./recommendList.vue?vue&type=style&index=0&id=008110fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008110fd",
  null
  
)

export default component.exports